import { render, staticRenderFns } from "./ActionsDropdown.vue?vue&type=template&id=460793f0&scoped=true"
import script from "./ActionsDropdown.vue?vue&type=script&lang=ts"
export * from "./ActionsDropdown.vue?vue&type=script&lang=ts"
import style0 from "./ActionsDropdown.vue?vue&type=style&index=0&id=460793f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460793f0",
  null
  
)

export default component.exports